import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

// Tokens de marca (espelham o mockup-os.html)
export const BD = {
  red: '#E40521',
  redDark: '#B5041A',
  redLight: '#FEE7E9',
  black: '#1A1A1A',
  grayText: '#6B7280',
  grayBorder: '#E5E7EB',
  grayBg: '#F9FAFB',
}

export const SEVERIDADE = {
  atencao: { bg: '#FEF3C7', texto: '#92400E', borda: '#F59E0B' },
  critico: { bg: '#FEE2E2', texto: '#991B1B', borda: '#991B1B' },
}

export const InternalShell = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${BD.grayBg};
`

export const Sidebar = styled.aside<{ $open?: boolean }>`
  width: 240px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid ${BD.grayBorder};
  padding: 16px 12px;
  @media (max-width: 1023px) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 40;
    overflow-y: auto;
    transition: transform 0.25s ease;
    transform: translateX(${({ $open }) => ($open ? '0' : '-100%')});
    box-shadow: ${({ $open }) => ($open ? '4px 0 24px rgba(0,0,0,0.15)' : 'none')};
  }
`

export const SidebarOverlay = styled.div<{ $open?: boolean }>`
  display: none;
  @media (max-width: 1023px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 35;
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
    transition: opacity 0.2s;
  }
`

export const Topbar = styled.div`
  display: none;
  @media (max-width: 1023px) {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #fff;
    border-bottom: 1px solid ${BD.grayBorder};
    position: sticky;
    top: 0;
    z-index: 30;
  }
`

export const Hamburger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid ${BD.grayBorder};
  border-radius: 8px;
  background: #fff;
  font-size: 18px;
  cursor: pointer;
  @media (max-width: 1023px) {
    width: 44px;
    height: 44px;
  }
`

export const MainCol = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

export const DetailLayout = styled.div<{ $contido?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $contido }) => ($contido ? 'minmax(0, 2fr) minmax(0, 1fr)' : '2fr 1fr')};
  gap: 20px;
  @media (max-width: 1023px) {
    grid-template-columns: ${({ $contido }) => ($contido ? 'minmax(0, 1fr)' : '1fr')};
  }
`

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  @media (max-width: 639px) {
    grid-template-columns: 1fr;
  }
`

export const Grid3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  align-items: end;
  @media (max-width: 639px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const SidebarBrand = styled.div`
  font-weight: 800;
  font-size: 15px;
  padding: 8px 12px 16px;
  color: ${BD.black};
  span {
    color: ${BD.red};
  }
`

export const SidebarLink = styled.a<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 4px;
  color: ${({ $active }) => ($active ? '#fff' : BD.black)};
  background: ${({ $active }) => ($active ? BD.red : 'transparent')};
  &:hover {
    background: ${({ $active }) => ($active ? BD.red : BD.grayBg)};
  }
`

/**
 * OP-3605 — cabecalho de grupo do menu. E um <button> de verdade: o grupo
 * abre e fecha, entao precisa chegar pelo teclado e anunciar-se.
 */
export const SidebarGroup = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  appearance: none;
  border: 0;
  background: none;
  font-family: inherit;
  padding: 6px 12px;
  margin-bottom: 4px;
  cursor: pointer;
  color: ${BD.grayText};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  &:hover {
    color: ${BD.black};
  }
`

export const SidebarGroupBox = styled.div`
  margin-bottom: 10px;
`

export const SidebarChevron = styled.span<{ $open?: boolean }>`
  display: flex;
  transition: transform 0.15s ease;
  transform: rotate(${({ $open }) => ($open ? '0deg' : '-90deg')});
`

export const Content = styled.main<{ $abas?: boolean }>`
  flex: 1;
  padding: 24px;
  min-width: 0;
  @media (max-width: 767px) {
    padding: 16px;
    padding-bottom: ${({ $abas }) => ($abas ? '88px' : '16px')};
  }
`

export const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 4px;
  color: ${BD.black};
`

export const PageSubtitle = styled.p`
  font-size: 13px;
  color: ${BD.grayText};
  margin-bottom: 20px;
`

export const Card = styled.div`
  background: #fff;
  border: 1px solid ${BD.grayBorder};
  border-radius: 12px;
  padding: 16px;
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const KpiCard = styled(Card)`
  padding: 14px 16px;
  .kpi-label {
    font-size: 12px;
    color: ${BD.grayText};
    font-weight: 500;
  }
  .kpi-value {
    font-size: 26px;
    font-weight: 800;
    color: ${BD.black};
  }
`

export const FiltersRow = styled(Card)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 639px) {
    grid-template-columns: 1fr;
  }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  label {
    font-size: 12px;
    font-weight: 500;
    color: ${BD.grayText};
    margin-bottom: 4px;
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${BD.grayBorder};
  border-radius: 8px;
  font-size: 14px;
  @media (max-width: 767px) {
    min-height: 44px;
    font-size: 16px;
  }
  &:focus {
    outline: none;
    border-color: ${BD.red};
    box-shadow: 0 0 0 3px rgba(228, 5, 33, 0.1);
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${BD.grayBorder};
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  @media (max-width: 767px) {
    min-height: 44px;
    font-size: 16px;
  }
  &:focus {
    outline: none;
    border-color: ${BD.red};
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  thead th {
    background: ${BD.grayBg};
    color: ${BD.grayText};
    font-size: 12px;
    font-weight: 600;
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid ${BD.grayBorder};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  tbody td {
    padding: 14px 12px;
    border-bottom: 1px solid ${BD.grayBorder};
    font-size: 14px;
  }
  tbody tr {
    transition: background 0.15s;
    cursor: pointer;
  }
  tbody tr:hover {
    background: ${BD.grayBg};
  }
`

export const StatusBadge = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`

export const Pill = styled.span<{ $bg: string; $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`

export const Spinner = styled.div.attrs((p: { role?: string; 'aria-label'?: string }) => ({
  role: p.role ?? 'status',
  'aria-label': p['aria-label'] ?? 'Carregando',
}))`
  width: 30px;
  height: 30px;
  border: 3px solid ${BD.grayBorder};
  border-top-color: ${BD.red};
  border-radius: 50%;
  margin: 0 auto;
  animation: ${spin} 0.7s linear infinite;
`

export const Button = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  @media (max-width: 767px) {
    min-height: 44px;
  }
  border: ${({ $variant }) => ($variant === 'secondary' ? `1px solid ${BD.grayBorder}` : 'none')};
  background: ${({ $variant }) => ($variant === 'secondary' ? '#fff' : BD.red)};
  color: ${({ $variant }) => ($variant === 'secondary' ? BD.black : '#fff')};
  &:hover {
    background: ${({ $variant }) => ($variant === 'secondary' ? BD.grayBg : BD.redDark)};
  }
  &:disabled {
    background: #E5E7EB;
    color: #4B5563;
    cursor: not-allowed;
  }
`

/**
 * OP-3619 — o módulo de Solicitações opera em campo, no celular.
 *
 * O corte é 767px: abaixo dele a tabela vira cartão, a barra de filtros vira
 * folha, a ação do estado atual desce para uma barra fixa e o menu lateral
 * vira barra de abas. Acima, nada muda — o desktop continua sendo a tela de
 * quem trabalha sentado.
 */
export const CELULAR = '(max-width: 767px)'

export const SoCelular = styled.div`
  display: none;
  @media ${CELULAR} {
    display: block;
  }
`

export const SoDesktop = styled.div`
  @media ${CELULAR} {
    display: none;
  }
`

export const TabelaWrap = styled.div`
  overflow-x: auto;
  @media ${CELULAR} {
    display: none;
  }
`

export const ListaCartoes = styled.div`
  display: none;
  @media ${CELULAR} {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`

/** A moldura da lista some no celular: o cartão já é a moldura. */
export const CaixaLista = styled(Card)`
  padding: 0;
  @media ${CELULAR} {
    border: 0;
    background: transparent;
    border-radius: 0;
  }
`

export const BarraChips = styled.div`
  display: none;
  @media ${CELULAR} {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const Chip = styled.button<{ $ativo?: boolean }>`
  flex-shrink: 0;
  height: 36px;
  padding: 0 14px;
  border-radius: 18px;
  font-family: inherit;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
  font-weight: ${({ $ativo }) => ($ativo ? 600 : 500)};
  border: 1px solid ${({ $ativo }) => ($ativo ? BD.black : BD.grayBorder)};
  background: ${({ $ativo }) => ($ativo ? BD.black : '#fff')};
  color: ${({ $ativo }) => ($ativo ? '#fff' : BD.black)};
  @media ${CELULAR} {
    height: 44px;
    border-radius: 22px;
  }
`

export const FolhaOverlay = styled.div<{ $open?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 45;
  background: rgba(0, 0, 0, 0.45);
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: opacity 0.2s;
`

export const Folha = styled.div<{ $open?: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 46;
  max-height: 88vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: 8px 16px calc(16px + env(safe-area-inset-bottom));
  box-shadow: 0 -8px 28px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease;
  transform: translateY(${({ $open }) => ($open ? '0' : '100%')});
  &:focus {
    outline: none;
  }
`

export const PainelLateral = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 46;
  width: min(440px, 100vw);
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
  &:focus {
    outline: none;
  }
`

export const FolhaPega = styled.div`
  width: 40px;
  height: 4px;
  margin: 0 auto 12px;
  border-radius: 2px;
  background: ${BD.grayBorder};
`

export const FolhaTopo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  h2 {
    flex-grow: 1;
    font-size: 17px;
    font-weight: 700;
    color: ${BD.black};
  }
`

export const BarraAcao = styled.div`
  display: none;
  @media ${CELULAR} {
    display: flex;
    gap: 10px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 25;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    border-top: 1px solid ${BD.grayBorder};
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
  }
`

export const EspacoBarraAcao = styled.div<{ $altura?: number }>`
  @media ${CELULAR} {
    height: ${({ $altura }) => $altura ?? 84}px;
  }
`

export const BotaoIcone = styled.button`
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${BD.grayBorder};
  border-radius: 12px;
  background: #fff;
  color: ${BD.grayText};
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const Abas = styled.nav`
  display: none;
  @media ${CELULAR} {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    background: #fff;
    border-top: 1px solid ${BD.grayBorder};
    padding-bottom: env(safe-area-inset-bottom);
  }
`

export const Aba = styled.span<{ $ativo?: boolean }>`
  flex: 1 1 0;
  min-width: 0;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 11px;
  font-weight: ${({ $ativo }) => ($ativo ? 600 : 500)};
  color: ${({ $ativo }) => ($ativo ? BD.red : BD.grayText)};
`

/**
 * O rótulo da aba, e só ele: "Remessas" não cabe em 78px e precisa de
 * reticências. A regra mora aqui, num componente próprio, porque como
 * descendente (`Aba span`) ela alcançava também o ícone — e o `overflow:
 * hidden` do ícone cortava o badge, que é posicionado para fora dele.
 */
export const AbaRotulo = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const AbaIcone = styled.span`
  position: relative;
  display: flex;
`

export const AbaBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -9px;
  box-sizing: border-box;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: ${BD.red};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
`

export const Fab = styled.span`
  display: none;
  @media ${CELULAR} {
    display: flex;
    align-items: center;
    gap: 8px;
    position: fixed;
    right: 16px;
    bottom: calc(80px + env(safe-area-inset-bottom));
    z-index: 26;
    height: 52px;
    padding: 0 20px;
    border-radius: 26px;
    background: ${BD.red};
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 6px 20px rgba(228, 5, 33, 0.35);
  }
`

export const Passo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PassoBotao = styled.button`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${BD.grayBorder};
  border-radius: 8px;
  background: #fff;
  color: ${BD.black};
  font-family: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  @media ${CELULAR} {
    width: 48px;
    height: 48px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const PassoCampo = styled.input`
  width: 72px;
  flex-grow: 1;
  max-width: 120px;
  padding: 8px;
  border: 1px solid ${BD.grayBorder};
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  @media ${CELULAR} {
    min-height: 48px;
  }
  &:focus {
    outline: none;
    border-color: ${BD.red};
  }
`

export const LinkBotao = styled.a<{ $primario?: boolean }>`
  flex: 1 1 0;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid ${({ $primario }) => ($primario ? BD.red : BD.grayBorder)};
  border-radius: 10px;
  background: ${({ $primario }) => ($primario ? BD.red : '#fff')};
  color: ${({ $primario }) => ($primario ? '#fff' : BD.black)};
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  &:hover {
    background: ${({ $primario }) => ($primario ? BD.redDark : BD.grayBg)};
    color: ${({ $primario }) => ($primario ? '#fff' : BD.black)};
  }
`
